import { Navigate } from "react-router-dom";
import { fieldState, privacyVisible, useSite } from "@/lib/content";
import { useSeo } from "@/lib/seo";
import { t } from "@/lib/i18n";
import PageIntro from "@/components/PageIntro";
import { Pending, UnverifiedTag } from "@/components/Pending";
import { path } from "@/lib/routes";

export default function Gizlilik() {
  useSeo("gizlilik");
  const { content, isPreview } = useSite();
  if (!privacyVisible(content, isPreview)) return <Navigate to={path("home")} replace />;
  const text = fieldState(content?.privacy?.text, isPreview);
  const updated = fieldState(content?.privacy?.updated_at, isPreview);

  return (
    <div data-testid="gizlilik-page">
      <PageIntro eyebrow={t("gizlilik.eyebrow")} title={t("gizlilik.title")} testId="gizlilik-intro" />
      <section className="safe-x max-w-3xl mx-auto lg:mx-[max(1rem,calc((100vw-80rem)/2+2rem))] pb-24">
        {text.usable ? (
          <div className="space-y-4">
            {!text.verified && <UnverifiedTag />}
            <div className="text-base leading-relaxed text-ink whitespace-pre-line" data-testid="privacy-text">{text.value}</div>
            {updated.usable && <p className="text-sm text-ink-muted">{t("gizlilik.updated")}: {updated.value}</p>}
          </div>
        ) : (
          <Pending testId="privacy-pending" />
        )}
      </section>
    </div>
  );
}
